import { cn } from "@/lib/utils";

type Props = { size?: "xs" | "sm" | "md" | "lg"; className?: string };

const CircularProgress = ({ size = "md", className }: Props) => {
  return (
    <span
      className={cn(
        "loading loading-spinner",
        {
          "loading-xs": size === "xs",
          "loading-sm": size === "sm",
          "loading-md": size === "md",
          "loading-lg": size === "lg",
        },
        className
      )}
    ></span>
  );
};

export default CircularProgress;
